module.exports = __webpack_public_path__ + "static/media/close.00c8f6ea.svg";